import React, { ReactNode } from "react";
import { useAuthUser } from "../../../hooks/auth/useAuthUser";

export function AdminOnlyComponents( props: { children: ReactNode }) {

    const { children } = props;

    const user = useAuthUser();
    if (!user.isAdmin()) {
        return null;
    }

    return <>{ children }</>;
}
